<template>
	<v-layout class="loading" align-center justify-center>
		<v-progress-circular
			:size="70"
			:width="7"
			color="primary"
			indeterminate
		></v-progress-circular>
	</v-layout>
</template>

<script>
	import { Auth } from "aws-amplify";

	export default {
		async created() {
			await Auth.signOut();
			this.$router.push('/auth');
		}
	}
</script>

<style>
	.loading {
		width: 100vw;
		height: 100vh;
		background: rgba(0,0,0,0.4);
		position: fixed;
		left: 0;
		top: 0;
		z-index: 9999;
	}
</style>
